import { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { getPasswordNotification } from 'store/recoverAccount-actions';

import Loading from 'components/UI/Loading/Loading';
import classes from './RecoverAccountSecondStep.module.css';

const RecoverAccountSecondStep = props => {
  const { t } = useTranslation(['recoverAccount']);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [value, setValue] = useState();

  const handleChange = event => {
    setValue(event.target.value);
    props.setAlias(event.target.value);
  };

  const sendAlias = () => {
    setIsLoading(true);
    dispatch(getPasswordNotification(value));
  };

  return (
    <>
      <FormControl>
        <RadioGroup value={value} onChange={handleChange}>
          {props.data.map(alias => (
            <FormControlLabel
              key={alias.alias}
              value={alias.alias}
              control={<Radio />}
              label={alias.newValueMask}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {!isLoading ? (
        <aside>
          <Button
            className={classes.cancelBtn}
            variant="outlined"
            component={Link}
            to="/"
          >
            {t('cancel')}
          </Button>
          <Button
            className={classes.searchBtn}
            variant="contained"
            disabled={!value}
            onClick={sendAlias}
          >
            {t('search')}
          </Button>
        </aside>
      ) : (
        <Loading />
      )}
    </>
  );
};

RecoverAccountSecondStep.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  setAlias: PropTypes.func
};

export default RecoverAccountSecondStep;
